import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLanguage20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconLanguage20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M.926 3h11.201v2.413a.75.75 0 0 1-1.5 0V4.5h-3.35v9h1.271a.75.75 0 0 1 0 1.5H4.504a.75.75 0 0 1 0-1.5h1.272v-9h-3.35v.913a.75.75 0 0 1-1.5 0zm13.206 10.322.387-.265A3.41 3.41 0 0 0 16 10.246V9h-1.543a.75.75 0 0 1-.414 0H9.298V7.5H13.5V6.2a.75.75 0 0 1 1.5 0v1.3h4V9h-1.5v1.246c0 1.5-.685 2.91-1.847 3.836l2.297 1.149a.75.75 0 0 1-.671 1.342l-3.027-1.514-3.144 2.154-.848-1.237 2.501-1.714a4.93 4.93 0 0 1-2.134-4.062h1.5c0 1.294.732 2.486 1.884 3.062z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLanguage20);
